/**
 * @fileoverview
 * Action Button Component - Reusable button component with icon support
 * Migrated to new architecture with OnPush change detection
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-action-button',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './action-button.component.html',
  styleUrl: './action-button.component.css',
})
export class ActionButtonComponent {
  private sanitizer = inject(DomSanitizer);

  @Input() label!: string;
  @Input() variant: 'filled' | 'outline' = 'filled';
  @Input() buttonClass: string = '';
  @Input() iconLeft: string = '';
  @Input() iconRight: string = '';
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';

  @Output() clicked = new EventEmitter<void>();

  get safeIconLeft(): SafeHtml | null {
    return this.iconLeft
      ? this.sanitizer.bypassSecurityTrustHtml(this.iconLeft)
      : null;
  }

  get safeIconRight(): SafeHtml | null {
    return this.iconRight
      ? this.sanitizer.bypassSecurityTrustHtml(this.iconRight)
      : null;
  }

  isSvgIcon(icon: string): boolean {
    return icon.trim().startsWith('<svg');
  }

  onClick(event: Event) {
    if (!this.disabled && !this.loading) {
      // Always emit clicked event for component consumers
      this.clicked.emit();
      
      // For submit buttons, don't prevent default to allow form submission
      // For other button types, prevent default to avoid unwanted form submission
      if (this.type === 'button' || this.type === 'reset') {
        event.preventDefault();
      }
      // For submit type, let the form handle submission naturally
    } else {
      event.preventDefault();
    }
  }
}

